class MainMenu extends HHBaseElement {
  constructor() {
    super()
    this._calculateHeaderHeight = this._calculateHeaderHeight.bind(this)
    this._syncScroll = this._syncScroll.bind(this)
    this._onScroll = this._onScroll.bind(this)
    this._onSearchToggle = this._onSearchToggle.bind(this)
    this._onKeydown = this._onKeydown.bind(this)

    this.backdrop = this.querySelector('.js-backdrop')
    this.announcementBar = this.querySelector('#shopify-section-section-announcement-bar')
    this.header = this.querySelector('#shopify-section-section-header')
    this.mql = window.matchMedia('(min-width: 992px)')

    this.headerBar = this.querySelector('.js-main-header')
    this.searchToggle = this.querySelector('[data-header-search-toggle]')
    this.searchBar = this.querySelector('#header-search-bar')
    this._scrollTicking = false
  }

  connectedCallback() {
    this._attachListeners()
    this._calculateHeaderHeight()
    this._initScroll()
    this._initSearch()
  }

  disconnectedCallback() {
    this._removeListeners()
  }

  showBackdrop() {
    this.backdrop?.classList.add('visible')
    if (!this.mql.matches) {
      document.documentElement.classList.add('frozen')
      document.body.classList.add('frozen')
    }
  }

  hideBackdrop() {
    this.backdrop?.classList.remove('visible')
    document.documentElement.classList.remove('frozen')
    document.body.classList.remove('frozen')
  }

  _attachListeners() {
    this.addEventListener('announcement-bar::ready', this._calculateHeaderHeight)
    window.addEventListener('resize', this._calculateHeaderHeight)
  }

  _removeListeners() {
    this.removeEventListener('announcement-bar::ready', this._calculateHeaderHeight)
    window.removeEventListener('resize', this._calculateHeaderHeight)
    window.removeEventListener('scroll', this._onScroll)
    document.removeEventListener('keydown', this._onKeydown)
    this.searchToggle?.removeEventListener('click', this._onSearchToggle)
  }

  _calculateHeaderHeight() {
    setTimeout(() => {
      const announcementHeight = this.announcementBar?.offsetHeight || 0
      document.documentElement.style.setProperty('--announcement-bar-height', announcementHeight + 'px')
      document.documentElement.style.setProperty(
        '--header-spacer',
        announcementHeight + (this.header?.offsetHeight || 0) + 'px'
      )
    }, 100)
  }

  _initScroll() {
    if (!this.headerBar) return
    this._syncScroll()
    window.addEventListener('scroll', this._onScroll, { passive: true })
  }

  _syncScroll() {
    this.headerBar.classList.toggle('is-scrolled', window.scrollY > 40)
    this._scrollTicking = false
  }

  _onScroll() {
    if (!this._scrollTicking) {
      window.requestAnimationFrame(this._syncScroll)
      this._scrollTicking = true
    }
  }

  _initSearch() {
    if (!this.searchToggle || !this.searchBar) return
    this.searchToggle.addEventListener('click', this._onSearchToggle)
    document.addEventListener('keydown', this._onKeydown)
  }

  _onSearchToggle() {
    const opening = this.searchToggle.getAttribute('aria-expanded') !== 'true'
    this.searchToggle.setAttribute('aria-expanded', opening ? 'true' : 'false')
    this.searchBar.hidden = !opening
    this.searchToggle.querySelector('.header__search-icon').hidden = opening
    this.searchToggle.querySelector('.header__close-icon').hidden = !opening
    if (opening) this.searchBar.querySelector('#header-search-input').focus()
  }

  _onKeydown(e) {
    if (e.key === 'Escape' && this.searchToggle.getAttribute('aria-expanded') === 'true') {
      this._onSearchToggle()
      this.searchToggle.focus()
    }
  }
}

window.customElements.define('main-menu', MainMenu)
